import { ActionTypes } from "../Constants/ActionTypes";

const initialState = {
    userData: {},
    securityOptions: [],
    userDetails: null,
    disableSave: false,
    firstNameError: "",
    middleNameError: "",
    lastNameError: "",
    displayedFirstNameError: "",
    displayedLastNameError: "",
    fieldsChangedRef: []
}

export const userDetailsReducer = (state=initialState, action) => {
    switch(action.type){
        case ActionTypes.USER_DETAIL: 
            return{
                ...state, 
                userData: action.payload?.formValues,
                securityOptions: action.payload?.securityOptions,
                userDetails: action.payload?.userDetails,
                disableSave: action.payload?.disableSave,
                firstNameError: action.payload?.firstNameError,
                middleNameError: action.payload?.middleNameError,
                lastNameError: action.payload?.lastNameError,
                displayedFirstNameError: action.payload?.displayedFirstNameError,
                displayedLastNameError: action.payload?.displayedLastNameError,
                fieldsChangedRef: action.payload?.fieldsChangedRef
            }
        default: 
            return state
    }
}